export const environment = {
    oneTrust: {
        scriptUrl: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
        domainScriptId: '018f7c3a-a4e6-7635-9956-1d1020d64416'
    },
    loginRedirectUrl: '/loginredirect',
};
